// A minimal SVG counterpart of `h()` for the few procedural UI doodles (summary art, spinner
// fallbacks). Attributes are always set as attributes; numbers are stringified.

const SVG_NS = 'http://www.w3.org/2000/svg';

export type SvgAttrs = Readonly<Record<string, string | number | boolean | null | undefined>>;

export function svg<K extends keyof SVGElementTagNameMap>(
  tag: K,
  attrs?: SvgAttrs | null,
  ...children: (SVGElement | string | null | undefined | false)[]
): SVGElementTagNameMap[K] {
  const el = document.createElementNS(SVG_NS, tag);
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) {
      if (v === null || v === undefined || v === false) continue;
      el.setAttribute(k, v === true ? '' : String(v));
    }
  }
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    el.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return el;
}
